import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Autoplay, EffectCoverflow } from 'swiper/modules';

import AmazonImg from "../assets/amazon.jpg";
import IbmImg from "../assets/ibm.jpg";
import CiscoImg from "../assets/cicsco.jpg";
import ItImg from "../assets/It.jpg";
import TataImg from "../assets/tata.jpg";
import GodrejImg from "../assets/godrej.jpg";
import OberoiImg from "../assets/oberoi.jpg";
import LalitImg from "../assets/lalit.jpg";
import DeloitteImg from "../assets/deloite.jpg";
import AccentureImg from "../assets/accenture.jpg";
import NvidiaImg from "../assets/nvideia.jpg";
import P1Img from "../assets/p-logo-29.webp";
import P2Img from "../assets/p-logo-36.webp";
import P3Img from "../assets/p-logo-35.webp";
import P4Img from "../assets/p-logo-34.webp";
import P5Img from "../assets/p-logo-26.webp";
import P6Img from "../assets/p-logo-10.webp";

import pahrmasun from "../assets/schools/pharma/placementlogo/sun.webp";
import pahrmaastellas from "../assets/schools/pharma/placementlogo/astellas.webp";
import pahrmaaurbindo from "../assets/schools/pharma/placementlogo/aurobindo.webp";
import pahrmacipla from "../assets/schools/pharma/placementlogo/cipla.webp";
import pahrmadrreddy from "../assets/schools/pharma/placementlogo/drreddy.webp";
import pahrmaglenmark from "../assets/schools/pharma/placementlogo/glenmark.webp";
import pahrmaintas from "../assets/schools/pharma/placementlogo/intas.webp";
import pahrmajohnson from "../assets/schools/pharma/placementlogo/johnson.webp";
import pahrmalupin from "../assets/schools/pharma/placementlogo/lupin.webp";
import pahrmapf from "../assets/schools/pharma/placementlogo/pf.webp";
import pahrmatorrent from "../assets/schools/pharma/placementlogo/torrent.webp";

const placementPartners = [
    { id: 1, image: AmazonImg, alt: 'Amazon', tagline: 'Innovate with the global leader in e-commerce' },
    { id: 2, image: CiscoImg, alt: 'Cisco', tagline: 'Powering the future of networking' },
    { id: 3, image: IbmImg, alt: 'IBM', tagline: 'Driving AI and cloud solutions' },
    { id: 4, image: TataImg, alt: 'Tata', tagline: 'Building a legacy of excellence' },
    { id: 5, image: ItImg, alt: 'IT Company', tagline: 'Shaping the digital frontier' },
    { id: 6, image: GodrejImg, alt: 'Godrej', tagline: 'Crafting quality for generations' },
    { id: 7, image: OberoiImg, alt: 'Oberoi', tagline: 'Redefining luxury hospitality' },
    { id: 8, image: LalitImg, alt: 'Lalit', tagline: 'Excellence in hospitality' },
    { id: 9, image: DeloitteImg, alt: 'Deloitte', tagline: 'Leading global consulting' },
    { id: 10, image: AccentureImg, alt: 'Accenture', tagline: 'Transforming businesses worldwide' },
    { id: 11, image: NvidiaImg, alt: 'Nvidia', tagline: 'Pioneering AI and graphics' },
    { id: 12, image: P1Img, alt: 'Partner 1', tagline: 'Innovating for a better future' },
    { id: 13, image: P2Img, alt: 'Partner 2', tagline: 'Empowering global solutions' },
    { id: 14, image: P3Img, alt: 'Partner 3', tagline: 'Driving technological breakthroughs' },
    { id: 15, image: P4Img, alt: 'Partner 4', tagline: 'Shaping industry standards' },
    { id: 16, image: P5Img, alt: 'Partner 5', tagline: 'Building tomorrow’s innovations' },
    { id: 17, image: P6Img, alt: 'Partner 6', tagline: 'Leading with vision and impact' },
    { id: 18, image: pahrmasun, alt: 'Partner 6', tagline: 'Leading with vision and impact' },
    { id: 19, image: pahrmaastellas, alt: 'Partner 6', tagline: 'Leading with vision and impact' },
    { id: 20, image: pahrmaaurbindo, alt: 'Partner 6', tagline: 'Leading with vision and impact' },
    { id: 21, image: pahrmacipla, alt: 'Partner 6', tagline: 'Leading with vision and impact' },
    { id: 22, image: pahrmadrreddy, alt: 'Partner 6', tagline: 'Leading with vision and impact' },
    { id: 23, image: pahrmaglenmark, alt: 'Partner 6', tagline: 'Leading with vision and impact' },
    { id: 24, image: pahrmaintas, alt: 'Partner 6', tagline: 'Leading with vision and impact' },
    { id: 25, image: pahrmajohnson, alt: 'Partner 6', tagline: 'Leading with vision and impact' },
    { id: 26, image: pahrmalupin, alt: 'Partner 6', tagline: 'Leading with vision and impact' },
    { id: 27, image: pahrmapf, alt: 'Partner 6', tagline: 'Leading with vision and impact' },
    { id: 28, image: pahrmatorrent, alt: 'Partner 6', tagline: 'Leading with vision and impact' },
];

const PlacementPartners = ({ className, showHeading = true }) => {
    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <div className={`w-full ${className} bg-gradient-to-br from-gray-50 via-white to-green-50 py-16 px-4 md:px-8 relative overflow-hidden`}>
            {/* Animated Background Elements */}
            <div className="absolute inset-0 opacity-20 pointer-events-none">
                <div className="absolute top-[-20%] left-[-15%] w-96 h-96 bg-green-300 rounded-full blur-3xl animate-pulse-slow"></div>
                <div className="absolute bottom-[-20%] right-[-15%] w-96 h-96 bg-blue-300 rounded-full blur-3xl animate-pulse-slow animation-delay-4000"></div>
            </div>

            {/* Custom Animations */}
            <style>{`
                @keyframes pulse-slow {
                    0%, 100% { transform: scale(1); opacity: 0.2; }
                    50% { transform: scale(1.2); opacity: 0.3; }
                }
                @keyframes fade-in {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes slide-up {
                    from { opacity: 0; transform: translateY(30px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .animate-pulse-slow {
                    animation: pulse-slow 8s infinite;
                }
                .animate-fade-in {
                    animation: fade-in 0.8s ease-out forwards;
                }
                .animate-slide-up {
                    animation: slide-up 0.8s ease-out forwards;
                }
                .glow {
                    box-shadow: 0 0 20px rgba(34, 197, 94, 0.3);
                }
                .swiper-pagination-bullet {
                    width: 10px;
                    height: 10px;
                    margin: 0 5px;
                    background: rgba(0, 0, 0, 0.3);
                    opacity: 0.7;
                }
                .swiper-pagination-bullet-active {
                    background: #22c55e;
                    opacity: 1;
                    transform: scale(1.3);
                }
            `}</style>

            {/* Heading Section */}
            {showHeading && (
                <div className="relative z-10 text-center mb-12">
                    <h2 className="text-4xl md:text-6xl font-extrabold text-[#0e4d38] tracking-tight animate-fade-in">
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-blue-600">
                            Our Esteemed Placement Partners
                        </span>
                    </h2>
                    <p className="mt-4 text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed animate-slide-up">
                        Partnering with global industry leaders, we empower our graduates to launch impactful careers with the world’s most innovative companies.
                    </p>
                </div>
            )}

            {/* Swiper Component */}
            <div className="w-full max-w-7xl mx-auto relative z-10">
                <Swiper
                    modules={[Pagination, Autoplay, EffectCoverflow]}
                    effect="coverflow"
                    grabCursor={true}
                    centeredSlides={true}
                    slidesPerView="auto"
                    breakpoints={{
                        0: { slidesPerView: 1, spaceBetween: 10 },
                        768: { slidesPerView: 2, spaceBetween: 20 },
                        1024: { slidesPerView: 3, spaceBetween: 30 },
                    }}
                    coverflowEffect={{
                        rotate: 40,
                        stretch: 0,
                        depth: 150,
                        modifier: 1,
                        slideShadows: false,
                    }}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    pagination={{
                        clickable: true,
                        bulletClass: 'swiper-pagination-bullet',
                        bulletActiveClass: 'swiper-pagination-bullet-active',
                    }}
                    onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
                    className="placement-partners-swiper pb-12"
                >
                    {placementPartners.map((partner, index) => (
                        <SwiperSlide key={partner.id} className="flex justify-center">
                            <div
                                className={`
                                    bg-white bg-opacity-80 backdrop-blur-md border border-gray-100 
                                    shadow-xl overflow-hidden transition-all duration-500 
                                    ${activeIndex === index 
                                        ? 'scale-105 shadow-2xl border-green-200 glow' 
                                        : 'scale-95 opacity-80'}
                                    hover:scale-105 hover:shadow-2xl hover:opacity-100
                                    flex flex-col items-center justify-center
                                    w-[250px] md:w-[300px] h-[300px] p-8
                                `}
                            >
                                <img
                                    src={partner.image}
                                    alt={partner.alt}
                                    aria-label={partner.alt}
                                    className="max-w-[180px] max-h-[100px] object-contain transition-transform duration-300 hover:scale-110"
                                />
                                {/* <p className="mt-4 text-center text-sm md:text-base font-semibold text-gray-700 animate-slide-up">
                                    {partner.tagline}
                                </p> */}
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            {/* Stats Section */}
            {/* <div className="relative z-10 mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto text-center">
                <div className="bg-white bg-opacity-90 backdrop-blur-sm p-6 rounded-lg shadow-md animate-slide-up">
                    <h3 className="text-3xl font-bold text-green-600">95%</h3>
                    <p className="text-gray-600 mt-2">Placement Rate</p>
                </div>
                <div className="bg-white bg-opacity-90 backdrop-blur-sm p-6 rounded-lg shadow-md animate-slide-up">
                    <h3 className="text-3xl font-bold text-green-600">50+</h3>
                    <p className="text-gray-600 mt-2">Global Recruiters</p>
                </div>
                <div className="bg-white bg-opacity-90 backdrop-blur-sm p-6 rounded-lg shadow-md animate-slide-up">
                    <h3 className="text-3xl font-bold text-green-600">10 LPA</h3>
                    <p className="text-gray-600 mt-2">Average Package</p>
                </div>
            </div> */}

            {/* Footer Note */}
            <div className="text-center mt-10 relative z-10">
                <p className="text-sm text-gray-500 italic">
                    * Connecting talent with opportunity at the world’s leading organizations
                </p>
            </div>
        </div>
    );
};

export default PlacementPartners;